import { render } from "./DrilldownBanner.vue?vue&type=template&id=a5448880&scoped=true"
import script from "./DrilldownBanner.vue?vue&type=script&lang=ts"
export * from "./DrilldownBanner.vue?vue&type=script&lang=ts"

import "./DrilldownBanner.vue?vue&type=style&index=0&id=a5448880&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a5448880"

export default script